import React, { Component } from 'react';
import CarePlanFiles from './Components/CarePlanFiles';
import FavoriteCarePlans from './Components/FavoriteCarePlans';

import { connect } from 'react-redux';
import { alertActions } from '../../../../_actions/alert.actions';
import { carePlanService } from '../../../../_services/careplan.service';
import { telehealthActions } from '../../../../_actions/telehealth.actions'
import { authenticationService } from '../../../../_services/authentication.service'
import { ButtonGroup, Button, Dropdown } from 'react-bootstrap'

import {
  setCurrent,
  setImaging,
  setCarePlan,
  setDiagnosis,
  clearCurrent,
  setPhysicalExam,
} from '../../../../_actions/careplan.actions'

class CreateCarePlan extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isSending: false,
      isSaving: false,
      saveBtnLabel: 'Save as Draft'
    }

    this.clearDraft = this.clearDraft.bind(this);
    this.saveDraft = this.saveDraft.bind(this);
    this.sendToPatient = this.sendToPatient.bind(this);
  }

  componentDidMount() {
    if (this.props.telehealth.carePlan) {
      this.props.dispatch(setCurrent(this.props.telehealth.carePlan));
    }
  }

  componentDidUpdate(prevProps) {
    if(prevProps.telehealth !== this.props.telehealth) {
      this.props.dispatch(setCurrent(this.props.telehealth.carePlan));
    }
  }

  componentWillUnmount() {
    this.props.dispatch(clearCurrent());
  }

  clearDraft() {
    this.setState({
      isSaving: true,
      saveBtnLabel: 'Clearing...'
    });

    carePlanService.clearDraft(this.props.telehealth)
      .then(() => {
        this.setState({
          isSaving: false,
          saveBtnLabel: 'Save as Draft'
        });

        this.props.dispatch(clearCurrent());
        this.props.dispatch(telehealthActions.getTelehealthById(this.props.telehealth.id));
        this.props.dispatch(alertActions.success('Draft cleared!'));
      })
      .catch(() => {
        this.setState({
          isSaving: false,
          saveBtnLabel: 'Save as Draft'
        });

        this.props.dispatch(alertActions.error('Could not clear care plan draft at this time. Please try again.'));
      });
  }

  saveDraft() {
    this.setState({
      isSaving: true,
      saveBtnLabel: 'Saving...'
    });

    carePlanService.save(this.props.telehealth, this.props.carePlan, this.props.files)
      .then(() => {
        this.setState({
          isSaving: false,
          saveBtnLabel: 'Save as Draft'
        });

        this.props.dispatch(telehealthActions.getTelehealthById(this.props.telehealth.id));
        this.props.dispatch(alertActions.success('Care Plan Saved! Click "Send to Patient" when ready to send.'));
      })
      .catch(() => {
        this.setState({
          isSaving: false,
          saveBtnLabel: 'Save as Draft'
        });

        this.props.dispatch(alertActions.error('Could not save care plan at this time. Please try again.'));
      });
  }

  sendToPatient() {
    this.setState({
      isSending: true,
    });

    carePlanService.save(this.props.telehealth, this.props.carePlan, this.props.files, true)
      .then(() => {
        this.setState({
          isSending: false,
        });

        this.props.dispatch(clearCurrent());
        this.props.dispatch(telehealthActions.getTelehealthById(this.props.telehealth.id));
        this.props.dispatch(alertActions.success('Care Plan Sent!'));
      })
      .catch(() => {
        this.setState({
          isSending: false,
        });

        this.props.dispatch(alertActions.error('Could not send care plan at this time. Please try again.'));
      });
  }

  render() {
    const { carePlan, dispatch } = this.props;
    const { isSending, isSaving, saveBtnLabel } = this.state;

    return <div className="card axs-shadow mt-4">
      <div className="card-header">
        <div className="row">
          <div className="col-6">
            <h6 className="m-0 p-0">Care Plan</h6>
          </div>
          <div className="col-6 text-right">
            {authenticationService.isLicensedUser &&
              <FavoriteCarePlans />
            }
          </div>
        </div>
      </div>
      <div className="card-body">
        <form>
          <div className="form-group">
            <label htmlFor="physicalExam">Physical Exam</label>
            <textarea rows="3" value={carePlan.physicalExam} onChange={(e) => { dispatch(setPhysicalExam(e.target.value)) }} className="form-control" id="physicalExam"></textarea>
          </div>
          <div className="form-group">
            <label htmlFor="imaging">Imaging</label>
            <textarea rows="3" value={carePlan.imaging} onChange={(e) => { dispatch(setImaging(e.target.value)) }} className="form-control" id="imaging"></textarea>
          </div>
          <div className="form-group">
            <label htmlFor="diagnosis"><span className="text-danger">*</span> Diagnosis</label>
            <textarea rows="3" value={carePlan.diagnosis} onChange={(e) => { dispatch(setDiagnosis(e.target.value)) }} className="form-control" id="diagnosis"></textarea>
          </div>
          <div className="form-group">
            <label htmlFor="carePlan"><span className="text-danger">*</span> Care Plan</label>
            <textarea rows="3" value={carePlan.carePlan} onChange={(e) => { dispatch(setCarePlan(e.target.value)) }} className="form-control" id="carePlan"></textarea>
          </div>

          <CarePlanFiles />
        </form>
      </div>
      <div className="card-footer">
        <div className="row">
          <div className="col">
            {!isSending &&
              <Dropdown as={ButtonGroup}>
                <Button
                  onClick={this.saveDraft}
                  disabled={isSaving || carePlan.diagnosis === '' || carePlan.carePlan === ''}
                  variant="outline-primary">{saveBtnLabel}</Button>

                {carePlan.status === 'draft' && <>
                  <Dropdown.Toggle disabled={isSaving} split variant="outline-primary" />

                  <Dropdown.Menu>
                    <Dropdown.Item onClick={this.clearDraft}>Clear</Dropdown.Item>
                  </Dropdown.Menu>
                </>}

              </Dropdown>
            }
          </div>
          <div className="col-6">
            {!isSaving &&
              <button onClick={this.sendToPatient}
                disabled={isSending || carePlan.diagnosis === '' || carePlan.carePlan === ''}
                type="button" className="btn btn-success btn-block">{isSending ? 'Sending...' : 'Send to Patient'}</button>
            }
          </div>
        </div>
      </div>
    </div>
  }
}

const mapStateToProps = state => {
  return {
    files: state.careplan.files,
    carePlan: state.careplan.current
  }
}

export default connect(mapStateToProps)(CreateCarePlan);